var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrCodeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75024 4.5H5.25024C4.83603 4.5 4.50024 4.83579 4.50024 5.25V9.75C4.50024 10.1642 4.83603 10.5 5.25024 10.5H9.75024C10.1645 10.5 10.5002 10.1642 10.5002 9.75V5.25C10.5002 4.83579 10.1645 4.5 9.75024 4.5Z",
    stroke: "#0E5AA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75024 13.5H5.25024C4.83603 13.5 4.50024 13.8358 4.50024 14.25V18.75C4.50024 19.1642 4.83603 19.5 5.25024 19.5H9.75024C10.1645 19.5 10.5002 19.1642 10.5002 18.75V14.25C10.5002 13.8358 10.1645 13.5 9.75024 13.5Z",
    stroke: "#0E5AA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7502 4.5H14.2502C13.836 4.5 13.5002 4.83579 13.5002 5.25V9.75C13.5002 10.1642 13.836 10.5 14.2502 10.5H18.7502C19.1645 10.5 19.5002 10.1642 19.5002 9.75V5.25C19.5002 4.83579 19.1645 4.5 18.7502 4.5Z",
    stroke: "#0E5AA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5002 13.5V16.5",
    stroke: "#0E5AA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5002 19.5H16.5002V13.5",
    stroke: "#0E5AA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5002 15H19.5002",
    stroke: "#0E5AA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5002 18V19.5",
    stroke: "#0E5AA7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeIcon);
export default __webpack_public_path__ + "static/media/qr-code-icon.28acc11ee82feda4d51ef8a4e1535f383dc4be7bc1d6f204ccf9840dd67e002f.svg";
export { ForwardRef as ReactComponent };